import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'formError' })
export class FormErrorPipe implements PipeTransform {
  constructor(private trans: TranslateService) {}
  transform(errors: any) {
    if (!errors) {
      return;
    }

    const errorsTypes = {
      required: 'INPUT_ERROR.DATA_IS_REQUIRED',
      validEmail: 'INPUT_ERROR.INVALID_EMAIL',
      validPhone: 'INPUT_ERROR.MOBILE_FORMAT',
      validMobileOrHousePhone: 'INPUT_ERROR.OTHER_PHONE_FORMAT',
      maxlength: 'INPUT_ERROR.MAX_CHARACTER_LIMIT',
      incorrect: 'INPUT_ERROR.OTHER_PHONE_FORMAT',
      matDatepickerParse: 'INPUT_ERROR.INVALID_FORMAT_DATE'
    };

    let message = '';
    for (const key in errors) {
      if (errorsTypes[key]) {
        message += `${this.trans.instant(errorsTypes[key])}. `;
      }
    }

    return message;
  }
}
